/*
 * 当前日期的前几个月
 * 使用 months('2019-05', 6) 返回数组 '["2019-05", "2019-04", ...]'
 */
const months = (date, len, res) => {
  let dateString = date
  date = new Date(date)
  res = []
  for (let i = 0; i < len; i++) {
    date.setMonth(date.getMonth() - 1)
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    res.push(date.getFullYear() + '-' + m)
  }
  let newDate = new Date(dateString)
  res.unshift(newDate.getFullYear() + '-' + ((newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)))
  return res
}

/*
 * 当前日期时间
 * 使用 today('YYYY-MM') 返回 '2019-05', today('YYYY-MM-DD') 返回 '2019-05-20', today() 默认返回包括时分秒
 */
const today = (type, Y, M, D, date) => {
  let n = new Date()
  Y = n.getFullYear()
  M = (n.getMonth() + 1) < 10 ? '0' + (n.getMonth() + 1) : n.getMonth() + 1
  D = n.getDate() < 10 ? '0' + n.getDate() : n.getDate()
  let HH = n.getHours() < 10 ? '0' + n.getHours() : n.getHours()
  let MM = n.getMinutes() < 10 ? '0' + n.getMinutes() : n.getMinutes()
  let SS = n.getSeconds() < 10 ? '0' + n.getSeconds() : n.getSeconds()
  let parts = ['-', ':', ' ']
  switch (type) {
    case 'YYYY-MM':
      date = Y + parts[0] + M
      break
    case 'YYYY-MM-DD':
      date = Y + parts[0] + M + parts[0] + D
      break
    case 'MM-DD':
      date = M + parts[0] + D
      break
    default:
      date = Y + parts[0] + M + parts[0] + D + parts[2] + HH + parts[1] + MM + parts[1] + SS
  }
  return date
}

/*
 * 当前日期的近几天
 * 使用 GetDateStr(3) 或 GetDateStr(-3)
 */

function GetDateStr (AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = (dd.getMonth() + 1) < 10 ? '0' + (dd.getMonth() + 1) : (dd.getMonth() + 1)// 获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()// 获取当前几号，不足10补0
  return y + '-' + m + '-' + d
}

/*
 * 计算两个日期是否在几个之内
 * 使用 MonthsBetw('2019-01-01', '2019-12-31', 12), 返回false或true
 */
const MonthsBetw = (date1, date2, m) => {
  let time1 = new Date(date1)
  let time2 = new Date(date2)
  let diffyear = time2.getFullYear() - time1.getFullYear()
  let diffmonth = diffyear * 12 + time2.getMonth() - time1.getMonth()
  if (diffmonth < 0) {
    return false
  }
  let diffDay = time2.getDate() - time1.getDate()
  if (diffmonth < m || (diffmonth === m && diffDay <= 0)) {
    if (diffmonth === m && diffDay === 0) {
      let timeA = time1.getHours() * 3600 + 60 * time1.getMinutes() + time1.getSeconds()
      let timeB = time2.getHours() * 3600 + 60 * time2.getMinutes() + time2.getSeconds()
      if (timeB - timeA > 0) {
        return false
      }
    }
    return true
  }
  return false
}

/*
 * 日期格式转时间戳
 * 使用 timestamp('2019-05') 或 timestamp('2019-05-20')
 */
const timestamp = (date) => {
  let stamp = new Date(date).getTime()
  return stamp
}

/*
 * 日期时间格式转时间戳
 * 使用 DatetimeStamp('2014-07-10 10:21:12')
 */
const DatetimeStamp = (datetime) => {
  let newDatetime = datetime.replace(/-/g, '/')
  let stamp = Date.parse(new Date(newDatetime)) / 1000
  return stamp
}

/*
 * 获得某月的最后一天
 * 使用 LastDay('2019', '5')
 */
const LastDay = (year, month) => {
  let newYear = year
  let newMonth = month++
  if (month > 12) {
    newMonth -= 12
    newYear++
  }
  let newDate = new Date(newYear, newMonth, 1)
  return (new Date(newDate.getTime() - 1000 * 60 * 60 * 24)).getDate()
}
/*
Date difference 计算两个日期的差
*/

const GetDateDiff = (date1, date2) => {
  const diffTime = Math.abs(new Date(date1).getTime() - new Date(date2).getTime())
  return diffTime / 1000 / 60 / 60 / 24
}
/*
 * 金额格式化
 * 使用 money(5000, 2), 金额和保留小数点位数
 */
const money = (num, point) => {
  let pow = 10 ** point
  num = num.toString().replace(/\$|/g, '')
  if (isNaN(num)) {
    num = '0'
  }
  let sign = (Number(num) === (num = Math.abs(num)))
  num = Math.floor(num * pow + 0.50000000001)
  let cents = num % pow
  num = Math.floor(num / pow).toString()
  if (cents < (pow / 10)) {
    cents = '0' + cents
  }
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
    num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
  }
  return (((sign) ? '' : '-') + num + '.' + cents)
}

/*
 * 隐藏电话显示开头号码段和尾号4位
 * 使用 hidetel('13800138000')
 */
const hidetel = (tel) => {
  let reg = /^(\d{3})\d{4}(\d{4})$/
  return tel.replace(reg, '$1****$2')
}
/*
  处理url参数
*/
const getRequest = (url) => {
  var theRequest = {}
  if (url.indexOf('?') !== -1) {
    // 获取url中"?"符后的字串
    var str = url.substr(url.indexOf('?') + 1)
    var j = url.indexOf('?')
    var k = url.indexOf('#')
    var strs = ''
    if (j > k) {
      strs = str.split('&')
    } else if (j < k) {
      let str2 = str.slice(0, str.indexOf('#'))
      strs = str2.split('&')
    }
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

/* 文本强制换行
  text  文本内容
  包含sign字符，强制换行
*/
const textWrap = (text) => {
  let reg = /\$/g
  let newText = text.replace(reg, '<br/>')
  return newText
}

/* 日期转中文 */
const dateToZh = (dateStr, format) => {
  let dict = {
    '0': '〇',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六',
    '7': '七',
    '8': '八',
    '9': '九',
    '10': '十',
    '11': '十一',
    '12': '十二',
    '13': '十三',
    '14': '十四',
    '15': '十五',
    '16': '十六',
    '17': '十七',
    '18': '十八',
    '19': '十九',
    '20': '二十',
    '21': '二十一',
    '22': '二十二',
    '23': '二十三',
    '24': '二十四',
    '25': '二十五',
    '26': '二十六',
    '27': '二十七',
    '28': '二十八',
    '29': '二十九',
    '30': '三十',
    '31': '三十一'
  }
  let date = dateStr.split('-')
  // console.log(date)
  let yy = date[0]
  let mm = date[1]
  let dd = date[2]
  let yearStr = dict[yy[0]] + dict[yy[1]] + dict[yy[2]] + dict[yy[3]] + '年'
  // console.log(yearStr)
  let monthStr = dict['' + Number(mm)] + '月'
  // console.log(monthStr)
  let dayStr = dict['' + Number(dd)] + '日'
  // console.log(dayStr)
  let dataZh = ''
  switch (format) {
    case 'YYYY-MM':
      dataZh = yearStr + monthStr
      break
    case 'YYYY-MM-DD':
      dataZh = yearStr + monthStr + dayStr
      break
    case 'MM-DD':
      dataZh = monthStr + dayStr
      break
  }
  return dataZh
}

export {
  months,
  today,
  timestamp,
  DatetimeStamp,
  MonthsBetw,
  LastDay,
  money,
  hidetel,
  GetDateStr,
  getRequest,
  GetDateDiff,
  textWrap,
  dateToZh
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils.js